import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogoMark } from "../components/Logo";
import { useApp } from "../context/AppContext";
import { useToast } from "../hooks/use-toast";
import { SECTORS, WILAYAS } from "../data/mock";
import { api } from "../services/api";

const Field = ({ label, children }) => (
  <label className="block">
    <span className="font-display font-semibold text-sm text-navy">{label}</span>
    <div className="mt-1.5">{children}</div>
  </label>
);

const inputCls = "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-orange focus:ring-2 focus:ring-orange/20 outline-none text-sm bg-white";

const Inscription = () => {
  const { t, tf, lang } = useApp();
  const { toast } = useToast();
  const navigate = useNavigate();
  const [consent, setConsent] = useState(false);
  const [form, setForm] = useState({ company: "", activity: "", contact: "", email: "", phone: "", wilaya: "", address: "", rc: "", password: "" });

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.activity) { toast({ title: "Ssuq", description: tf({ fr: "Choisissez votre type de client.", ar: "اختر نوع الزبون." }) }); return; }
    if (!consent) { toast({ title: "Ssuq", description: t("signup_consent") }); return; }
    try {
      await api.createClient({ company: form.company, activity: form.activity, contact: form.contact, email: form.email, phone: form.phone, wilaya: form.wilaya, address: form.address, rc: form.rc });
      toast({ title: "Ssuq ✔", description: t("signup_ok") });
      setTimeout(() => navigate("/catalogue"), 900);
    } catch {
      toast({ title: "Ssuq", description: tf({ fr: "Erreur lors de l'inscription. Réessayez.", ar: "خطأ أثناء التسجيل. حاول مجدداً." }) });
    }
  };

  return (
    <div className="pt-28 pb-24 min-h-screen bg-cream">
      <div className="max-w-lg mx-auto px-5">
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-10">
          <div className="flex flex-col items-center text-center">
            <LogoMark size={52} />
            <span className="mt-4 inline-block bg-orange/10 text-orange font-display font-semibold text-xs px-3 py-1 rounded-full">{t("signup_label")}</span>
            <h1 className="font-display font-black text-3xl text-navy mt-3">{t("signup_title")}</h1>
          </div>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <Field label={t("f_company")}><input required value={form.company} onChange={set("company")} className={inputCls} /></Field>
            <Field label={t("f_activity")}>
              <div className="flex flex-wrap gap-2">
                {SECTORS.map((s) => {
                  const val = lang === "ar" ? s.ar : s.fr;
                  const active = form.activity === val;
                  return (
                    <button type="button" key={s.id} onClick={() => setForm({ ...form, activity: val })}
                      className={`font-display font-semibold text-sm px-4 py-2 rounded-full border transition-colors ${active ? "bg-navy text-white border-navy" : "bg-white text-navy border-gray-200 hover:border-navy"}`}>
                      {val}
                    </button>
                  );
                })}
              </div>
            </Field>
            <div className="grid grid-cols-2 gap-4">
              <Field label={t("f_contact")}><input required value={form.contact} onChange={set("contact")} className={inputCls} /></Field>
              <Field label={t("f_phone")}><input required value={form.phone} onChange={set("phone")} className={inputCls} /></Field>
            </div>
            <Field label={t("f_email")}><input type="email" required value={form.email} onChange={set("email")} className={inputCls} /></Field>
            <Field label={t("f_wilaya")}>
              <select required value={form.wilaya} onChange={set("wilaya")} className={inputCls}>
                <option value="">{t("f_select")}</option>
                {WILAYAS.map((w) => <option key={w} value={w}>{w}</option>)}
              </select>
            </Field>
            <Field label={t("f_address")}><textarea required rows={2} value={form.address} onChange={set("address")} className={`${inputCls} resize-none`} placeholder="N°, rue, quartier, commune, wilaya, points de repère…" /></Field>

            <label className="flex items-start gap-3 cursor-pointer pt-1">
              <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-1 w-4 h-4 accent-orange" />
              <span className="text-xs text-gray-500 leading-relaxed">{t("signup_consent")}</span>
            </label>

            <button type="submit" className="w-full btn-orange font-display font-semibold rounded-full py-3.5">{t("signup_btn")}</button>
          </form>

          <p className="text-center text-sm text-gray-500 mt-6">{t("already")} <Link to="/connexion" className="text-orange font-semibold hover:underline">{t("signin")}</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Inscription;
